export const shipmentStatuses = {
  900: 'text-grey',
  901: 'text-brown',
  902: 'text-yellow',
  903: 'text-yellow',
  904: 'text-blue',
  905: 'text-green',
  906: 'text-red',
  907: 'text-orange',
  908: 'text-purple',
  909: 'text-teal',
  910: 'text-teal',
  911: 'text-green',
  912: 'text-olive',
  913: 'text-green',
  914: 'text-red',
  1000: 'text-black',
  915: 'text-orange',
  917: 'text-red',
  '-1': 'text-blue'
}

export const shipmentStatusesBg = {
  900: '#A0A0A0',
  901: '#a5673f',
  902: '#FFD700',
  903: '#FFD700',
  904: '#0E6EB8',
  905: '#32CD32',
  906: '#db2828',
  907: '#FE9A76',
  908: '#B413EC',
  909: '#008080',
  910: '#008080',
  911: '#32CD32',
  912: '#b5cc18',
  913: '#32CD32',
  914: '#db2828',
  1000: '#000000',
  915: '#FE9A76',
  916: '#32CD32',
  917: '#db2828'
}



// WEBPACK FOOTER //
// ./src/stubs/shipments.js